import { createReducer } from '@reduxjs/toolkit';

import { initialState } from 'state/allSlices';
import {
  getInitialSlice,
  resetSlices,
  resetStateToInitial,
  restoreState
} from './reset-state-actions';

export const resetState = createReducer(initialState, (builder) => {
  builder
    .addCase(resetSlices, (state, action) => {
      const { payload } = action;
      state = {
        ...state,
        ...getInitialSlice(payload, initialState)
      };

      return state;
    })
    .addCase(resetStateToInitial, () => {
      return initialState;
    })
    .addCase(restoreState, (state, action) => {
      return action.payload.store;
    });
});
